/**
 * SECURITY FIX M-3: Sanitize URL parameters to prevent XSS and injection
 */
export function getFiltersFromUrl() {
  const params = new URLSearchParams(window.location.search);

  // Sanitize device parameter
  const deviceRaw = params.get("device") || "";
  const device = deviceRaw.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 64);

  // Validate date parameters (ISO format)
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  const startRaw = params.get("start");
  const endRaw = params.get("end");

  const start = startRaw && datePattern.test(startRaw) ? startRaw : null;
  const end = endRaw && datePattern.test(endRaw) ? endRaw : null;

  return { device, start, end };
}

/**
 * SECURITY FIX M-3: Sanitize parameters before setting in URL
 */
export function setFiltersToUrl({ device, start, end }) {
  const params = new URLSearchParams(window.location.search);

  // Sanitize device
  if (device) {
    const safeDevice = device.replace(/[^A-Za-z0-9_-]/g, "").slice(0, 64);
    if (safeDevice) params.set("device", safeDevice);
    else params.delete("device");
  } else {
    params.delete("device");
  }

  // Validate dates
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  if (start && datePattern.test(start)) {
    params.set("start", start);
  } else {
    params.delete("start");
  }

  if (end && datePattern.test(end)) {
    params.set("end", end);
  } else {
    params.delete("end");
  }

  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState(null, "", newUrl);
}
